module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid padding-15 sm-padding-10 split-container"
  }, [_c('div', {
    staticClass: "row full-height"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "panel full-height"
  }, [_c('div', {
    staticClass: "col-md-3 no-padding no-margin full-height"
  }, [_c('OrganizationList', {
    ref: "list",
    on: {
      "selected": _vm.onSelected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 no-padding no-margin panel full-height"
  }, [_c('Organization', {
    ref: "detail",
    attrs: {
      "organization": _vm.selected
    },
    on: {
      "reload": _vm.onReload
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel m-t-45 no-padding m-b-5"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "no-margin p-t-10 p-b-10"
  }, [_vm._v("Organizations")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bb38ed8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Organizations.vue
// module id = 1383
// module chunks = 1